import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-layouts',
  templateUrl: './layouts.component.html',
  styleUrls: ['./layouts.component.css']
})
export class LayoutsComponent implements OnInit {

  constructor(public meta: Meta, public title: Title) {
  }

  ngOnInit() {
    const pageTitle: string = 'PHP Shopping cart using Bootstrap templates';

    this.meta.addTag({
      name: 'description',
      content: 'Sell digital and physical content using Bootstrap templates'
    });
    this.title.setTitle(pageTitle);
  }

}
